import { render, staticRenderFns } from "./priceSystem.vue?vue&type=template&id=44a5f37c&scoped=true"
import script from "./priceSystem.vue?vue&type=script&lang=js"
export * from "./priceSystem.vue?vue&type=script&lang=js"
import style0 from "./priceSystem.vue?vue&type=style&index=0&id=44a5f37c&prod&lang=css"
import style1 from "./priceSystem.vue?vue&type=style&index=1&id=44a5f37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a5f37c",
  null
  
)

export default component.exports